import React, { useContext } from 'react';
import './Loader.scss';
import { ForgeBusyIndicator } from '@tylertech/forge-extended-react';
import { LoaderContext } from '../../../contexts/loaderContext.js';

const Loader = () => {
  const { loading, loadingMessage } = useContext(LoaderContext);

  return (
    <>
      {loading && (
        <ForgeBusyIndicator open message={loadingMessage ? loadingMessage : 'Loading...'} />
      )}
    </>
  );
};

export default Loader;
